module.exports = __webpack_public_path__ + "img/icon-totop.e60ad5cb.svg";